function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2531 30.9723C30.0135 33.325 26.7119 34.5128 23.4333 35.4493C20.1316 36.3629 16.8531 37.0025 13.5745 36.4772C10.296 35.9518 7.01741 34.2387 5.23959 31.5662C3.46176 28.9165 3.18469 25.3076 3.39248 21.8585C3.62337 18.4094 4.38531 15.1431 6.34782 13.0188C8.28724 10.8945 11.4735 9.93513 14.8906 8.06212C18.3308 6.16627 22.048 3.37959 25.7653 3.3339C29.4594 3.28822 33.1767 6.00638 35.0468 9.52399C36.8939 13.0416 36.917 17.3587 36.3167 21.2646C35.7164 25.1705 34.5158 28.6425 32.2531 30.9723Z",
  fill: "#E9FAF5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4243 25.0758L13.2807 24.7124C13.6625 23.2963 14.1156 21.4201 14.4492 19.4289L14.7611 19.1772H26.5426L26.946 19.4552C27.2799 21.4404 27.7317 23.3097 28.1123 24.7204L27.9804 25.0805C27.9572 25.1025 27.93 25.1281 27.8988 25.1573C27.7814 25.2669 27.6084 25.4249 27.3891 25.615C26.9499 25.996 26.3286 26.5032 25.6 27.0092C24.1134 28.0417 22.2944 28.9875 20.6956 28.9875C19.0971 28.9875 17.2829 28.0419 15.8014 27.0097C15.0751 26.5038 14.4562 25.9967 14.0189 25.6158C13.8005 25.4257 13.6282 25.2677 13.5113 25.1581C13.4776 25.1265 13.4485 25.0989 13.4243 25.0758Z",
  stroke: "#676F8F",
  strokeWidth: 1.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9335 18.9302L16.2055 18.736H14.3279L13.6947 19.188C13.359 21.0181 12.8804 22.7509 12.4907 24.0131H12.4908L12.7464 24.5852C12.7464 24.5852 13.3703 25.1341 14.338 25.8013C14.9051 23.7482 15.4835 21.3832 15.9335 18.9302Z",
  fill: "#1ECD96"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7429 10.7924C20.7429 10.7924 20.7429 10.7924 20.7429 10.7924L32.9758 15.2728L20.9186 21.6433C20.509 21.8597 20.035 21.8597 19.6253 21.6433L7.56823 15.2728L19.8011 10.7924C19.8011 10.7924 19.8011 10.7924 19.8012 10.7924C20.1072 10.6804 20.4369 10.6804 20.7429 10.7924Z",
  fill: "#E9FAF5",
  stroke: "#676F8F",
  strokeWidth: 1.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7673 26.4578C30.5414 26.4578 30.3583 26.2594 30.3583 26.0146V17.8175C30.3583 17.6071 30.2272 17.423 30.0393 17.3698L20.8089 14.7323C20.5904 14.6699 20.4601 14.4274 20.5177 14.1907C20.5753 13.954 20.7988 13.8125 21.0174 13.8751L30.247 16.5124C30.7938 16.6672 31.1763 17.2039 31.1763 17.8175V26.0145C31.1763 26.2594 30.9932 26.4578 30.7673 26.4578Z",
  fill: "#B6EFDD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4828 26.9998H30.0509L29.8806 29.87C29.8665 30.1078 30.0357 30.3094 30.2495 30.3094H31.2842C31.498 30.3094 31.6672 30.1078 31.6531 29.87L31.4828 26.9998Z",
  fill: "#51D8AE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8125 29.87L30.9828 26.9998H30.0509L29.8806 29.87C29.8665 30.1078 30.0357 30.3094 30.2495 30.3094H31.1814C30.9676 30.3094 30.7984 30.1078 30.8125 29.87Z",
  fill: "#1ECD96"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0981 24.937H30.4352C30.105 24.937 29.8348 25.2298 29.8348 25.5877V26.8794C29.8348 26.9969 29.9227 27.0922 30.0311 27.0922H31.5023C31.6107 27.0922 31.6986 26.9969 31.6986 26.8794V25.5877C31.6985 25.2297 31.4284 24.937 31.0981 24.937Z",
  fill: "#51D8AE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8892 26.8794V25.5877C30.8892 25.304 31.0592 25.0619 31.294 24.9733C31.2325 24.9502 31.1668 24.9369 31.0983 24.9369H30.4354C30.1051 24.9369 29.8349 25.2298 29.8349 25.5877V26.8794C29.8349 26.9969 29.9228 27.0921 30.0312 27.0921H31.0855C30.9771 27.0921 30.8892 26.9969 30.8892 26.8794Z",
  fill: "#51D8AE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3563 13.0705C19.5699 13.0188 18.9173 13.6947 18.9173 14.5357V14.5432C18.9191 14.9214 19.2115 15.2229 19.5605 15.2229H20.9835C21.3209 15.2229 21.6461 14.94 21.625 14.4638C21.5923 13.7232 21.0393 13.1153 20.3563 13.0705Z",
  fill: "#1ECD96"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1443 14.5432C20.1443 14.5407 20.1443 14.5382 20.1443 14.5357C20.1443 13.9654 20.4446 13.4714 20.8829 13.2283C20.7225 13.1393 20.5447 13.0829 20.3563 13.0705C19.5699 13.0188 18.9173 13.6947 18.9173 14.5357V14.5432C18.9191 14.9214 19.2115 15.2229 19.5605 15.2229H20.7875C20.4385 15.2229 20.1461 14.9214 20.1443 14.5432Z",
  fill: "#00B57C"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0529 24.0131C26.6314 25.2792 24.32 26.6964 21.8229 27.5684C20.8332 27.9142 19.7362 27.923 18.7212 27.5684C16.2298 26.6983 13.9192 25.2845 12.4912 24.0131C12.3546 24.4556 12.2288 24.8405 12.1241 25.151C11.9442 25.6844 12.0992 26.2841 12.5112 26.635C14.7941 28.5795 17.2039 29.6419 18.7212 30.1719C19.2222 30.3469 19.7456 30.4344 20.272 30.4344C20.7985 30.4344 21.3218 30.3469 21.8229 30.1719C23.3402 29.6419 25.7499 28.5795 28.0328 26.635C28.4448 26.2841 28.5998 25.6844 28.4199 25.151C28.3152 24.8404 28.1895 24.4555 28.0529 24.0131Z",
  fill: "#676F8F"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4302 25.4656C13.6845 24.9854 13.0258 24.4893 12.4909 24.013C12.3543 24.4555 12.2286 24.8404 12.1238 25.1509C11.9439 25.6843 12.0989 26.284 12.5109 26.6349C12.9416 27.0017 13.3766 27.337 13.8094 27.6434C14.0112 26.966 14.2205 26.2363 14.4302 25.4656Z",
  fill: "#494F66"
});

var SvgBirrete = function SvgBirrete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBirrete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/birrete.e7fbf5ad.svg";
export { ForwardRef as ReactComponent };